import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './home.css'; 
import CustomerFeedback from '../Components/CustomerFeedback';
import SubscriptionBanner from '../Components/SubscriptionBanner';
import BannerSlider from '../Components/BannerSlider';
import WhyChooseUs from '../Components/WhyChooseUs';
import { db } from '../firebase'; 
import { collection, getDocs } from 'firebase/firestore';

function Home() {
  const [homeMealCategory, setHomeMealCategory] = useState(null);
  const [dietPlanCategory, setDietPlanCategory] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000 });

    const fetchCategories = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "categories"));
        const categoriesData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        const homeMeal = categoriesData.find(cat => cat.name === 'Home Meal');
        const dietPlan = categoriesData.find(cat => cat.name === 'Diet Plan');

        setHomeMealCategory(homeMeal);
        setDietPlanCategory(dietPlan);

      } catch (error) {
        console.error("Error fetching categories from Firestore: ", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <div> 
      <div className="homepage-section compact">
        <SubscriptionBanner />
      </div>

      <section className="product top-selling homepage-section">
        <div className="container">
          <div className="grocery-section">
            <div className="row g-5">
              {/* Home Meal Card */}
              <div className="col-lg-3 col-md-6">
                <Link 
                  to={homeMealCategory ? `/category/${homeMealCategory.id}/meals` : "/package"} 
                  className="product-wrapper-link"
                >
                  <div className="product-wrapper">
                    <div className="card-image-top">
                      <img src="/assets/images/homepage-one/home-meal.png" alt="Home Meal"/>
                    </div>
                    <div className="wrapper-info">
                      <h3 className="wrapper-details">Home Meal</h3>
                      <h5 className="wrapper-details">Daily deliciousnes</h5>
                      
                      <div className="order-now-btn">Order now</div>
                    </div>
                  </div>
                </Link>
              </div>
              
              {/* Fitness & Diet Meal Card */}
              <div className="col-lg-3 col-md-6">
                <Link 
                  to={dietPlanCategory ? `/category/${dietPlanCategory.id}/meals` : "/package"} 
                  className="product-wrapper-link"
                >
                  <div className="product-wrapper">
                    <div className="card-image-top">
                      <img src="/assets/images/homepage-one/diet-plan.png" alt="Fitness & Diet Meal"/>
                    </div>
                    <div className="wrapper-info">
                      <h3 className="wrapper-details">Fitness & Diet Meal</h3>
                      <h5 className="wrapper-details">Meals that heal</h5>
                      
                      <div className="order-now-btn">Order now</div>
                    </div>
                  </div>
                </Link>
              </div>
              
              {/* Party Orders Card */}
              <div className="col-lg-3 col-md-6">
                <Link to="/party-orders" className="product-wrapper-link">
                  <div className="product-wrapper">
                    <div className="card-image-top">
                      <img src="/assets/images/homepage-one/party-orders.png" alt="Party Orders"/>
                    </div>
                    <div className="wrapper-info">
                        <h3 className="wrapper-details">Party Orders</h3>
                        <h5 className="wrapper-details">Your Feast, Party</h5>
                         
                        <div className="order-now-btn">Order now</div>
                    </div>
                  </div>
                </Link>
              </div>
              
              {/* Add-ons & Side Dish Card */}
              <div className="col-lg-3 col-md-6">
                <Link to="/addons" className="product-wrapper-link">
                  <div className="product-wrapper">
                    <div className="card-image-top">
                      <img src="/assets/images/homepage-one/add-ons.png" alt="Add-ons"/>
                    </div>
                    <div className="wrapper-info">
                        <h3 className="wrapper-details">Add-onns & Side Dish</h3>
                        <h5 className="wrapper-details">Complete your meal</h5>
                        
                        <div className="order-now-btn">Order now</div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* ✅ ADDED A WRAPPER SECTION FOR STYLING */}
      <section className="banner-slider-section homepage-section">
        <div className="container">
            <h2 className="section-title-new" style={{ color: '#333' }}></h2>
            <BannerSlider />
        </div>
      </section>
      
      <div className="homepage-section">
        <WhyChooseUs />
      </div>
        
      <section className="steps-to-order-new homepage-section">
        <div className="container">
          <h2 className="steps-title-new">
            Steps To <span className="highlight">Order</span>
            <div className="title-underline"></div>
          </h2>
          
          <div className="steps-container">
            <div className="roadmap-step" data-aos="fade-right" data-aos-delay="400">
              <div className="step-content-card">
                <div className="step-number-badge">01</div>
                <h3>Choose Your Type of Meal</h3>
                <p>Browse our diverse menu and select your preferred dishes from our carefully curated collection</p>
                <Link to="/package" className="step-action-btn">
                  Browse Menu
                  <svg width="18" height="18" viewBox="0 0 16 16" fill="none"><path d="M3.3335 8H12.6668" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M8 3.33337L12.6667 8.00004L8 12.6667" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </Link>
              </div>
              <div className="step-image" data-aos="fade-left" data-aos-delay="400">
                <img src="/assets/images/homepage-one/step1.jpg" alt="Choose Your Favourite Cuisine" />
              </div>
            </div>

            <div className="roadmap-step" data-aos="fade-left" data-aos-delay="500">
              <div className="step-content-card">
                <div className="step-number-badge">02</div>
                <h3>Select Your Meal Combo & Dates</h3>
                <p>Customize your meal plan with preferred dates and combinations that suit your schedule</p>
                <Link to="/package" className="step-action-btn">
                  Customize Plan
                  <svg width="18" height="18" viewBox="0 0 16 16" fill="none"><path d="M3.3335 8H12.6668" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M8 3.33337L12.6667 8.00004L8 12.6667" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </Link>
              </div>
              <div className="step-image" data-aos="fade-right" data-aos-delay="500">
                <img src="/assets/images/homepage-one/step2.jpg" alt="Select Your Meal Combo & Dates" />
              </div>
            </div>

            <div className="roadmap-step" data-aos="fade-right" data-aos-delay="600">
              <div className="step-content-card">
                <div className="step-number-badge">03</div>
                <h3>Get Your Favourite Meal at Home</h3>
                <p>Enjoy delicious, freshly prepared meals delivered hot to your doorstep on time</p>
                <Link to="/package" className="step-action-btn primary">
                  Start Ordering
                  <svg width="18" height="18" viewBox="0 0 16 16" fill="none"><path d="M3.3335 8H12.6668" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M8 3.33337L12.6667 8.00004L8 12.6667" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </Link>
              </div>
              <div className="step-image" data-aos="fade-left" data-aos-delay="600">
                <img src="/assets/images/homepage-one/step3.jpg" alt="Get Your Favourite Meal at Home" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* /<div className="customer-feedback-container homepage-section"> */}
        {/* <CustomerFeedback /> */}
      {/* </div> */}
    </div>
  )
}

export default Home;